import gql from 'graphql-tag'

export default gql`
  mutation membership_products_update_mutation(
    $id: ID!
    $description: String!
    $mailchimpTag: String!
    $slug: String!
    $stripeProductId: String!
    $title: String!
  ) {
    membershipProductUpdate(
      id: $id
      description: $description
      mailchimpTag: $mailchimpTag
      slug: $slug
      stripeProductId: $stripeProductId
      title: $title
    ) {
      id
    }
  }
`
